<div #container>
   <header class="header items-center px-4 py-2">
      <div class="flex flex-col gap-y-2">
         <span class="mat-headline-medium mb-0!">{{ reportData().campaign.client.organisation }}</span>
         <span class="mat-headline-small mb-0!">{{ reportData().campaign.name }}</span>
      </div>
      <div class="flex justify-center">
         <shared-ui-inline-svg
            class="text-primary"
            src="{{ 'images/environments/webvis/MediaVision_logo_text.svg' | assetLoader }}"
         ></shared-ui-inline-svg>
      </div>
      <div class="flex justify-end">
         <shared-ui-inline-svg
            class="text-primary"
            src="{{ 'images/environments/webvis/abovomaxlead-logo.svg' | assetLoader }}"
         ></shared-ui-inline-svg>
      </div>
   </header>

   <mat-divider class="col-span-full my-4"></mat-divider>

   <section class="grid grid-cols-4 gap-x-4 px-4 col-span-full">
      <div class="flex flex-col">
         <span class="mat-title-medium">{{ 'intermediate_report.general_info' | translate }}</span>
         <table>
            <tr>
               <td>{{ 'intermediate_report.investment' | translate }}</td>
               <td>{{ report().investment | currency }}</td>
            </tr>
            <tr>
               <td>{{ 'campaigns.fee' | translate }}</td>
               <td>{{ reportData().campaign.fee | percent }}</td>
            </tr>
            <tr>
               <td>{{ 'campaigns.start_date' | translate }}</td>
               <td>{{ reportData().campaign.start_date | customDate }}</td>
            </tr>
            <tr>
               <td>{{ 'campaigns.end_date' | translate }}</td>
               <td>{{ reportData().campaign.end_date | customDate }}</td>
            </tr>
            <tr>
               <td>{{ 'intermediate_report.report_date' | translate }}</td>
               <td>{{ report().report_date | customDate }}</td>
            </tr>
         </table>
      </div>
      <div>
         <span class="mat-title-medium">{{ 'campaign_briefing.media_objectives' | translate }}</span>
         <ul class="list-disc pl-5">
            @for (objective of mediaPlan().media_objectives; track objective.id) {
               <li>{{ objective.name }}</li>
            }
         </ul>
      </div>
      <div>
         <span class="mat-title-medium">{{ 'media_campaign.disciplines' | translate }}</span>
         <ul class="list-disc pl-5">
            @for (discipline of reportData().disciplines; track discipline.id) {
               <li>{{ discipline.category?.name }}</li>
            }
         </ul>
      </div>
      <div>
         <span class="mat-title-medium">{{ 'campaigns.target_audience' | translate }}</span>
         <p class="whitespace-pre-line">{{ targetAudience() }}</p>
      </div>
   </section>

   <mat-divider class="col-span-full my-4"></mat-divider>

   <section class="col-span-full px-4 pdf:hidden flex gap-8">
      <webvis-feature-manage-flights [flights]="reportData().flights"></webvis-feature-manage-flights>
      <mat-checkbox [(ngModel)]="showPlannedColumn">{{ 'intermediate_report.toggle_planned_column' | translate }} </mat-checkbox>
      <mat-checkbox [(ngModel)]="showIntermediateColumn">{{ 'intermediate_report.toggle_intermediate_column' | translate }} </mat-checkbox>
      <mat-checkbox [(ngModel)]="showRemark">{{ 'intermediate_report.toggle_remark' | translate }}</mat-checkbox>
      <mat-checkbox [(ngModel)]="showMediaBundles">{{ 'intermediate_report.show_media_bundles' | translate }} </mat-checkbox>
   </section>

   @if (showRemark()) {
      <section class="p-4 w-1/2">
         <div class="text-lg font-semibold">{{ 'intermediate_report.remark' | translate }}</div>
         @if (reportData().report.remark) {
            <div class="whitespace-pre-line pt-2">{{ reportData().report.remark }}</div>
         } @else {
            <div class="opacity-50 italic pt-2">{{ 'intermediate_report.no_remark' | translate }}</div>
         }
      </section>
   }

   <section class="col-span-full px-4 pb-4">
      <webvis-ui-intermediate-report-grid-container
         [flights]="reportData().flights"
         [hiddenFlightIds]="hiddenFlightIds()"
         [intermediateReport]="report()"
         [mediaPlan]="mediaPlan()"
         [readonly]="true"
         [reportForm]="reportForm()"
         [selectedView]="'flights'"
         [showIntermediateColumn]="showIntermediateColumn()"
         [showMediaBundles]="showMediaBundles()"
         [showPlannedColumn]="showPlannedColumn()"
      ></webvis-ui-intermediate-report-grid-container>
   </section>

   <mat-divider class="col-span-full my-8"></mat-divider>

   <section class="dossier-block px-4 pb-4 col-span-full max-w-full">
      @for (dossier of dossiersTransformed(); track dossier.id) {
         <div
            [class.pdf:hidden]="!selectedDossierIds().includes(dossier.id)"
            class="flex gap-x-4"
         >
            <mat-checkbox
               (change)="toggleDossier(dossier.id)"
               [checked]="selectedDossierIds().includes(dossier.id)"
               class="pdf:hidden"
            ></mat-checkbox>
            <shared-ui-dossier-item-v2
               [dossier]="dossier"
               [hideDates]="true"
               [loadingType]="'eager'"
               [readonly]="true"
               class="grow"
            ></shared-ui-dossier-item-v2>
         </div>
      }
   </section>
   <button
      (click)="savePDF()"
      [extended]="true"
      class="fixed bottom-4 right-4 pdf:hidden"
      mat-fab
      type="button"
   >
      <fa-icon
         [fixedWidth]="true"
         [icon]="['far', 'file-export']"
         class="mr-2"
      ></fa-icon>
      <span>{{ 'intermediate_report.export_as_pdf' | translate }}</span>
   </button>
</div>
